import React from 'react';
import '../styles/Description.css';

const Description = () => {
    return (
        <div className="description-section">
            <div className="heading">
                <h2>Jurassic Park, But Real</h2>
            </div>
            <div className="description">
                <p>Are you ready to embark on a riveting journey through epics penned by the ancients themselves? Set foot into the awe-inspiring Edakkal Caves – the place where history, mystery, and adventure intertwine. Dare to uncover the tales that the caves have whispered to the earth since millennia.</p>
            </div>
        </div>
    );
}

export default Description;